import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface TipoViaje {
  id?: number;
  descripcion: string;
}

@Injectable({
  providedIn: 'root',
})
export class TipoViajeService {
  private apiUrl =  `${environment.apiUrl}/api/tipo_viaje`; 
  //private apiUrl = 'http://localhost:3000/api/tipo_viaje'; // Asegúrate de que apunte al dominio si ya está en producción

  constructor(private http: HttpClient) {}

  // Crear nuevo tipo de viaje
  crear(tipoViaje: TipoViaje): Observable<TipoViaje> {
    return this.http.post<TipoViaje>(this.apiUrl, tipoViaje, {
      withCredentials: true,
    });
  }

  // Obtener todos los tipos de viaje
  getAll(): Observable<TipoViaje[]> {
    return this.http.get<TipoViaje[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  obtenerPorId(id: number): Observable<TipoViaje> {
    return this.http.get<TipoViaje>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }
}
